import React, { Component } from "react";
import { Link } from "react-router-dom";
import Question from "./question";
import UserImage from "../user_image";
class QuestionLine extends Component {
  state = {};
  render() {
    return (
      <div className="row max_width_500">
        <div className="width_image_question">
          <UserImage user={this.props.question.user} />
        </div>
        {this.renderLink()}
      </div>
    );
  }

  renderShowQuestionAnswer() {
    if (this.props.showAnswer) {
      var numberToRender = this.props.question.answer_number;
      if (this.props.question.answer_number === 0) {
        numberToRender = "";
      }
      return (
        <div className="question_answers">
          {numberToRender}
          <ion-icon name="ios-arrow-forward" class="ion-icon" />
        </div>
      );
    }
    return <div />;
  }
  renderLink() {
    if (this.props.showAnswer) {
      const style = { width: "100%", height: "100%" };
      return (
        <React.Fragment>
          <Link
            className="width_text_question btn cursor_btn"
            to={{
              pathname: "/question/" + this.props.question.id,
              state: { fromApp: true }
            }}
          >
            <div>
              <Question question={this.props.question} />
            </div>
          </Link>
          <Link
            className="width_image_question btn cursor_btn"
            to={"/question/" + this.props.question.id}
          >
            <div style={style} className="width_image_question">
              {this.renderShowQuestionAnswer()}
            </div>
          </Link>
        </React.Fragment>
      );
    }
    return (
      <React.Fragment>
        <div className="width_text_question">
          <Question question={this.props.question} />
        </div>
        <div className="width_image_question">
          {this.renderShowQuestionAnswer()}
        </div>
      </React.Fragment>
    );
  }
}

export default QuestionLine;



// WEBPACK FOOTER //
// ./src/components/questions/question_line.jsx